var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0875 12C0.897624 11.8213 0.70559 11.6443 0.51734 11.464C0.343696 11.2971 0.173838 11.1259 0.0056034 10.9605C0.00560341 10.9445 0.00560341 10.9355 0.00560341 10.9264C0.00560341 10.9173 0.00560223 10.9072 0.0110117 10.9024C1.66793 9.26773 3.32485 7.63413 5.00233 5.98027L0.000196461 1.048C0.0440132 1.00373 0.0991878 0.949333 0.153823 0.893866L1.0334 -5.39118e-07L1.14159 -5.2966e-07C1.19893 0.0655995 1.24978 0.134933 1.31415 0.195733C3.27563 2.13102 5.23764 4.06578 7.2002 6C5.23836 7.93458 3.27635 9.86933 1.31415 11.8043C1.25249 11.8651 1.19893 11.9344 1.14159 12L1.0875 12Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.f3f4c6828a5b1189da940b5521ed1484.svg";
export { ForwardRef as ReactComponent };